// deno-lint-ignore-file no-explicit-any
/// <reference lib="dom" />
import { render } from "hono/jsx/dom";
import { components } from "@/components/registry.tsx";

declare global {
  interface Window {
    __DATA__: {
      component: keyof typeof components;
      props: any;
    };
  }
}

const root = document.getElementById("root");

if (root) {
  const { component, props } = window.__DATA__ || {};

  if (component && components[component]) {
    // Full Page Hydration
    const Component = components[component];
    render(
      <Component {...props} />,
      root,
    );
  }
}

// ALWAYS Hydrate Islands
const islands = document.querySelectorAll("[data-island]");
islands.forEach((island) => {
  const componentName = island.getAttribute(
    "data-island",
  ) as keyof typeof components;
  const propsStr = island.getAttribute("data-props");
  const props = propsStr ? JSON.parse(propsStr) : {};

  if (components[componentName]) {
    const Component = components[componentName];
    render(
      <Component {...props} />,
      island as HTMLElement,
    );
  }
});
